import {PrepState} from "../models/prep-state.interface";
import {DataType} from "../models/chart-selector-props.interface";
import {VisualisationDataInterface} from "../models/visualisation-data.interface";

export const makeDataGroup = (
    prep: PrepState,
    dataType: DataType,
    vData: VisualisationDataInterface[],
    year: number,
) => {
    const prepKeys = Object.keys(prep);
    const prepArray = Object.values(prep);
    const group = vData[year][dataType];
    const entries = Object.entries(group);
    const filtered = entries
        .map(([key, val]) =>
            ([
                key,
                val
                    .map((val, i) => ({[prepKeys[i]]: val}))
                    .filter((val, i) => prepArray[i])
            ])
        );

    return Object.fromEntries(filtered);
}